module.exports = __webpack_public_path__ + "static/media/ua-lamp-image-2.8acf1930.jpg";